app.controller("subscriptionCheckoutCtrl", [
  "$scope",
  "$location",
  "StripePaymentFactory",
  "$localStorage",
  "SubscriptionFactory",
  "checkUser",
  "getSiteDetails",
  function (
    $scope,
    $location,
    StripePaymentFactory,
    $localStorage,
    SubscriptionFactory,
    checkUser,
    getSiteDetails
  ) {
    const siteUrl = fullSite.siteURL;
    checkUser.checkLoginAndVerify(
      () => {},
      () => {
        $localStorage.redirect = window.location.href;
        $location.path("/login");
      }
    );
    $scope.subscribePageElements = [];

    const customerId = $localStorage.shopUserID;
    $scope.isCheckingCustomerHasSubscription = true;
    $scope.customerHasSubscription = false;
    $scope.isRetrievingPaymentIntent = false;
    $scope.hasPaymentIntent = false;
    $scope.paymentErrorMessage = null;
    $scope.isPaymentInFlightOrLoading = true;
    $scope.stripeErrorMessage = null;

    SubscriptionFactory.getCustomerSubscription().then(
      function () {
        $scope.isCheckingCustomerHasSubscription = false;
        $scope.customerHasSubscription = true;
      },
      function () {
        $scope.isCheckingCustomerHasSubscription = false;
        $scope.customerHasSubscription = false;
      }
    );

    /* Stripe details */

    function initStripeForm(stripeToken) {
      const stripe = Stripe(stripeToken);

      SubscriptionFactory.createSubscription(customerId)
        .then(
          (response) => {
            const elements = stripe.elements({
              clientSecret: response.clientSecret,
            });

            const form = document.getElementById("payment-form");
            form.addEventListener("submit", (event) => {
              event.preventDefault();

              $scope.isPaymentInFlightOrLoading = true;
              $scope.$apply();

              //TODO (ajb): update to correct URL
              stripe
                .confirmPayment({
                  elements,
                  confirmParams: {
                    return_url: `${siteUrl}/?redirect=orderComplete`,
                  },
                })
                .then(
                  function (result) {
                    if (result.error) {
                      $scope.paymentErrorMessage = result.error.message;
                      $scope.$apply();
                      $scope.isPaymentInFlightOrLoading = false;
                    }
                  },
                  function (err) {
                    $scope.isPaymentInFlightOrLoading = false;
                  }
                );
            });

            const paymentElement = elements.create("payment");
            paymentElement.mount("#payment-element");

            paymentElement.on("ready", function (event) {
              $scope.isPaymentInFlightOrLoading = false;
              $scope.$apply();
            });
          },
          (error) => {
            Sentry.captureMessage(error.statusText);
            $scope.stripeErrorMessage =
              "There was an error setting up the subscription";
          }
        )
        .catch((error) => console.log(error));
    }

    function initStripeResult(stripeToken) {
      if (stripeToken != false && stripeToken != null) {
        $("#payBtn").prop("disabled", false);
        initStripeForm(stripeToken);
      } else {
        $scope.keysSet = false;
      }
    }

    function initStripe() {
      StripePaymentFactory.stripeConnectToken().then(function (stripeToken) {
        initStripeResult(stripeToken);
      });
    }

    function getPaymentIntent() {
      $scope.isRetrievingPaymentIntent = true;

      SubscriptionFactory.getSubscriptionDetails(fullSite.micrositeID)
        .then(function (response) {
          $scope.subscriptionDetails = response;
          $scope.isRetrievingPaymentIntent = false;
          $scope.hasPaymentIntent = true;
          initStripe();
        })
        .catch((error) => console.log(error));
    }

    $scope.getPaymentIntent = getPaymentIntent;

    getSiteDetails
      .getSubscribePageElements(fullSite.micrositeID)
      .then((result) => {
        $scope.subscribePageElements = result.content;

        $scope.subscribePageElements = result.content.map((element) => {
          if (element.type === "Subscription") {
            element.type = "Subscription";
            element.payload.getPaymentIntent = getPaymentIntent;
          }
          return element;
        });
      })
      .catch((err) => {
        $scope.subscribePageElements = [];
      });
  },
]);
